import { render, staticRenderFns } from "./AccessIframe.vue?vue&type=template&id=72822c52&"
import script from "./AccessIframe.vue?vue&type=script&lang=js&"
export * from "./AccessIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports